"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.populateFieldsWithTranslations = exports.formatTranslations = exports.createTranslationsObject = exports.saveAsDefault = exports.acceptedLanguage = void 0;
const lodash_1 = require("lodash");
const types__graphql_1 = require("@caterdesk/types--graphql");
__exportStar(require("./specific-helpers"), exports);
const acceptedLanguage = (language) => {
    const languageValues = Object.values(types__graphql_1.Language);
    if (typeof language === "string" && languageValues.includes(language)) {
        return language;
    }
    return null;
};
exports.acceptedLanguage = acceptedLanguage;
const saveAsDefault = (language, defaultLanguage, currentTranslations) => {
    if (!language || !defaultLanguage)
        return true;
    if (language === types__graphql_1.Language.En || !currentTranslations)
        return true;
    const existingLanguages = (0, lodash_1.uniq)(Object.keys(currentTranslations).map((key) => key.split("_")[1]));
    if (existingLanguages.includes(types__graphql_1.Language.En))
        return false;
    if (language === defaultLanguage)
        return true;
    if (existingLanguages.includes(defaultLanguage))
        return false;
    return true;
};
exports.saveAsDefault = saveAsDefault;
const createTranslationsObject = (fields, language) => {
    const lang = (0, exports.acceptedLanguage)(language);
    const translationFields = {};
    if (lang) {
        Object.entries(fields).forEach(([key, value]) => {
            const translationKey = `${key}_${lang}`;
            translationFields[translationKey] = value;
        });
    }
    return translationFields;
};
exports.createTranslationsObject = createTranslationsObject;
const formatTranslations = (object) => {
    const { translations } = object;
    const translationsArray = translations
        ? Object.keys(translations)
            .filter((key) => (0, exports.acceptedLanguage)(key.split("_")[1]))
            .filter((key) => typeof translations[key] === "string")
            .map((key) => {
            const [field, language] = key.split("_");
            return {
                language: language,
                key: field,
                value: translations[key],
            };
        })
        : [];
    return {
        ...object,
        translations: translationsArray,
    };
};
exports.formatTranslations = formatTranslations;
const populateFieldsWithTranslations = (object, language) => {
    var _a;
    const translatedObject = { ...object };
    const translationsForGivenLanguage = ((_a = object.translations) === null || _a === void 0 ? void 0 : _a.filter((t) => t.language === language)) || [];
    translationsForGivenLanguage.forEach((translation) => {
        if (typeof translation.value === "string") {
            translatedObject[translation.key] = translation.value;
        }
    });
    return translatedObject;
};
exports.populateFieldsWithTranslations = populateFieldsWithTranslations;
